import CostUpload from "./components/templates/CostUpload/CostUpload";
import CJWUpload from "./components/templates/CJWUpload/CJWUpload";
import SVCUpload from "./components/templates/SVCUpload/SVCUpload";
import CostUploadHistory from "./components/templates/CostUploadHistory/CostUploadHistory";
import ManageUsers from "./components/templates/ManageUsers/ManageUsers";
import CJWManageHistory from "./components/templates/CJWManageHistory/CJWManageHistory";
import SVCManageHistory from "./components/templates/SVCManageHistory/SVCManageHistory";
import LandedCostUpload from "./components/templates/LandedCostUpload/LandedCostUpload";
import LandedCostSkuExclusion from "./components/templates/LandedCostSkuExclusion/LandedCostSkuExclusion";
import LandedCostAntiDumping from "./components/templates/LandedCostAntiDumping/LandedCostAntiDumping";
import LandedCostDataView from "./components/templates/LandedCostDataView/LandedCostDataView";
import LandedCostResults from "./components/templates/LandedCostResults/LandedCostResults";
import NewItemView from "./components/templates/LandedCostResults/NewItemView";
import FlaggedItems from "./components/templates/FlaggedItems/FlaggedItems";
import RulesPage from "./components/templates/Rules/RulesPage";
import UserAssignment from "./components/templates/UserAssignment/UserAssignment";
import LandedCostTariff from "./components/templates/LandedCostTariff/LandedCostTariff";
import LandedCostContainerRate from "./components/templates/LandedCostContainerRate/LandedCostContainerRate";
import LandedCostCalculation from "./components/templates/LandedCostCalculation/LandedCostCalculation";
import DCCostEstimation from "./components/templates/DCCostFlow/DCCostEstimation";
import DCBlockedItems from "./components/templates/DCCostFlow/DCBlockedItems";
import DCCostApprovals from "./components/templates/DCCostFlow/DCCostApprovals";
import DCCostBatchDetail from "./components/templates/DCCostFlow/DCCostBatchDetail";
import DCManualPull from "./components/templates/DCCostFlow/DCManualPull";
import DCEscalationReviews from "./components/templates/DCCostFlow/DCEscalationReviews";
//import LandedCostRunDetails from "./components/templates/LandedCostRunDetails/LandedCostRunDetails";
//import LandedCostRunDetailsEdit from "./components/templates/LandedCostRunDetailsEdit/LandedCostRunDetailsEdit";

export const routes = [
     {
        path:'/cjw-Upload',
        element:CJWUpload,
        permission:[],
        exact:true
    },
    {
        path:'/cost-upload',
        // element: CJWUpload,
        element: CostUpload,
        // element: SVCUpload,
        permissions:[],
        exact:true
    },
    {
        path:'/cost-upload-history',
        element:CostUploadHistory,
        permission:[],
        exact:true
    },
    {
        path:'/manage-users',
        element:ManageUsers,
        permission:[],
        exact:true
    },   
    {
        path:'/user-assignment',
        element:UserAssignment,
        permission:[],
        exact:true
    },
    {
        path: '/svc-upload',
        element:SVCUpload,
        permission:[],
        exact:true
    },
    {
        path: '/cjw-manage-history',
        element:CJWManageHistory,
        permission:[],
        exact:true
    },
    {   
        path: '/svc-manage-history',
        element:SVCManageHistory,   
        permission:[],
        exact:true
    },
    {
      path: "/landed-cost/upload-vendor",
      element: LandedCostUpload,
      permission: [],
      exact: true,
    },
    {
      path: "/landed-cost/sku-exclusion",
      element: LandedCostSkuExclusion,
      permission: [],
      exact: true,
    },
    {
      path: "/landed-cost/anti-dumping",
      element: LandedCostAntiDumping,
      permission: [],
      exact: true,
    },
    {
      path: "/landed-cost/tariff-data",
      element: LandedCostTariff,
      permission: [],
      exact: true,
    },
    {
      path: "/landed-cost/container-rate",
      element: LandedCostContainerRate,
      permission: [],
      exact: true,
    },
    {
      path: "/landed-cost/calculation",
      element: LandedCostCalculation,
      permission: [],
      exact: true,
    },
    {
      path: "/landed-cost/data-view",
      element: LandedCostDataView,
      permission: [],
      exact: true,
    },
    {
      path: "/landed-cost/results",
      element: LandedCostResults,
      permission: [],
      exact: true,
    },
    {
      path: "/landed-cost/new-item-view",
      element: NewItemView,
      permission: [],
      exact: true,
    },
    {
      path: "/flagged-items",
      element: FlaggedItems,
      permission: [],
      exact: true,
    },
    {
      path: "/rules",
      element: RulesPage,
      permission: [],
      exact: true,
    },
    {
      path: "/dc-cost/estimation",
      element: DCCostEstimation,
      permission: [],
      exact: true,
    },
    {
      path: "/dc-cost/blocked-items",
      element: DCBlockedItems,
      permission: [],
      exact: true,
    },
    {
      path: "/dc-cost/approvals",
      element: DCCostApprovals,
      permission: [],
      exact: true,
    },
    {
      path: "/dc-cost/approvals/detail",
      element: DCCostBatchDetail,
      permission: [],
      exact: true,
    },
    {
      path: "/dc-cost/manual-pull",
      element: DCManualPull,
      permission: [],
      exact: true,
    },
    {
      path: "/dc-cost/escalation-reviews",
      element: DCEscalationReviews,
      permission: [],
      exact: true,
    },
    // {
    //   path: "/landed-cost/run-details",
    //   element: LandedCostRunDetails,
    //   permission: [],
    //   exact: true,
    // },
    // {
    //   path: "/landed-cost/run-details/edit",
    //   element: LandedCostRunDetailsEdit,
    //   permission: [],
    //   exact: true,
    // },

]
